export const validators = {
  number: (value) => /^[0-9]*$/.test(value),
  korean: (value) => /^[ㄱ-ㅎㅏ-ㅣ가-힣]*$/.test(value), //  한글
  english: (value) => /^[a-zA-Z]*$/.test(value), // 영문
  string: (value) => /^[a-zA-Zㄱ-ㅎㅏ-ㅣ가-힣\s]*$/.test(value), // 영문 + 한글 + 공백
};
